import React, { useState, useEffect, useRef } from 'react';
import { Input } from './input';
import { motion, AnimatePresence } from 'framer-motion';

export function AutocompleteInput({ 
  value, 
  onChange, 
  suggestions, 
  placeholder, 
  className,
  id,
  required,
  "data-testid": dataTestId
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    if (value && isOpen) {
      const filtered = suggestions.filter(suggestion =>
        suggestion.toLowerCase().includes(value.toLowerCase()) &&
        suggestion.toLowerCase() !== value.toLowerCase()
      ).slice(0, 5);
      setFilteredSuggestions(filtered);
    } else {
      setFilteredSuggestions([]);
    }
  }, [value, suggestions, isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (suggestion) => {
    onChange({ target: { value: suggestion, id } });
    setIsOpen(false);
  };

  return (
    <div className="relative w-full" ref={containerRef}>
      <Input
        id={id}
        value={value}
        onChange={(e) => {
          onChange(e);
          setIsOpen(true);
        } }
        onFocus={() => setIsOpen(true)}
        placeholder={placeholder}
        className={className}
        required={required}
        data-testid={dataTestId}
        autoComplete="off"
      />
      <AnimatePresence>
        {isOpen && filteredSuggestions.length > 0 && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute z-50 w-full mt-1 bg-[#1a1a1a] border border-white/10 rounded-lg shadow-xl overflow-hidden"
          >
            {filteredSuggestions.map((suggestion, index) => (
              <li
                key={index}
                onClick={() => handleSelect(suggestion)}
                className="px-4 py-2 hover:bg-white/5 cursor-pointer text-sm transition-colors"
              >
                {suggestion}
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
}
